import { ReactElement } from 'react';
import TerminateEmployeeAccess from './TerminateEmployeeStepper/TerminateEmployeeAccess';
import withQueryCheck from 'pages/AnnualUserAccessReview/components/withQueryCheck';

/**
 * Form to submit when manager wishes to review and validate employee access
 * @returns {ReactElement} User Access Review Employee Review Form
 */
const ReviewForm = props => {
	return <TerminateEmployeeAccess {...props} />;
};

export default withQueryCheck(ReviewForm);
